import { Card, Typography, Divider, Button, Space } from "antd";
import styles from "assets/scss/jobAndClientBillingRules.module.scss";
import { useHistory, useParams } from "react-router-dom";
import { CommissionPlanDetails } from "./commissionPlanDetails/commissionPlanDetails";
import { EditIconButton } from "../../../../common/components/iconButton/editIconButton";

const { Title } = Typography;

export default function CurrentCommissionPlans({
  plansDetails,
  setEditModalVisible,
  onStartDateUpdated = null,
  isEditAllowed = false,
}) {
  const history = useHistory();
  const { planId } = useParams();

  return (
    <Card
      className={`${styles.clientBillingRulesCard} ${styles.commissionPlanDetails}`}
    >
      <Space direction="vertical" size="middle" style={{ width: "100%" }}>
        <div>
          <div>
            <Button
              type="link"
              className="backButton"
              onClick={() => history.push("/configurations/commission-plans")}
            >
              <i className="icon-back-arrow" />
              Back
            </Button>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 20 }}>
            <Space align="baseline">
              <Title level={5} className={styles.commissionPlanTitle}>
                {plansDetails.basicInfo.name}
              </Title>
              { isEditAllowed && (
                <EditIconButton
                  showTooltip={false}
                  onClick={() => setEditModalVisible(true)}
                />
              )}
            </Space>
            <Divider className={styles.titleDivider} plain />
            { isEditAllowed && (
              <Button
                onClick={() =>
                  history.push(
                    `/configurations/commission-plan/add-new/${planId}`,
                  )
                }
              >
                Add New Rule
              </Button>
            )}
          </div>
        </div>

        <CommissionPlanDetails
          plan={plansDetails.currentRule.defaultPlan.plan}
          commissionId={planId}
          lastRuleStartDate={
            plansDetails.histroyRules[0]?.defaultPlan.startDate
          }
          startDate={plansDetails.currentRule.defaultPlan.startDate}
          onStartDateUpdated={onStartDateUpdated}
          isEditAllowed={isEditAllowed}
        />
        {plansDetails.currentRule.clinetException.map((item, index) => (
          <CommissionPlanDetails
            key={index}
            plan={item.plan}
            clientName={item.plan.client.name}
          />
        ))}
      </Space>
    </Card>
  );
}
